// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"784":"df9e4e91","854":"97bffe59","935":"d8f22a91"}[chunkId] + ".js";
};